module.exports = __webpack_public_path__ + "img/underwriting_reports.3b2af03f.png";